// 字段映射配置 - 45+产品成本字段的中英文映射
import { FieldConfig, FieldGroup, SelectOption } from '../types/field-mapping';

// 字段分组配置
export const FIELD_GROUPS: Record<string, FieldGroup> = {
  basic: {
    key: 'basic',
    label: '基础信息',
    description: '产品和工厂的基本标识信息',
    order: 1,
    collapsible: false,
    defaultExpanded: true,
    icon: 'InfoCircleOutlined',
    color: '#1890ff'
  },
  product: {
    key: 'product',
    label: '产品信息',
    description: '产品代码、名称、原料等信息',
    order: 2,
    collapsible: true,
    defaultExpanded: true,
    icon: 'AppstoreOutlined',
    color: '#52c41a'
  },
  quantity: {
    key: 'quantity',
    label: '数量信息',
    description: '产量、原料、次品等数量相关数据',
    order: 3,
    collapsible: true,
    defaultExpanded: true,
    icon: 'BarChartOutlined',
    color: '#faad14'
  },
  rates: {
    key: 'rates',
    label: '比率指标',
    description: '亏耗率、出成率等比率指标',
    order: 4,
    collapsible: true,
    defaultExpanded: false,
    icon: 'PercentageOutlined',
    color: '#722ed1'
  },
  costs: {
    key: 'costs',
    label: '成本明细',
    description: '各项成本费用的详细分解',
    order: 5,
    collapsible: true,
    defaultExpanded: true,
    icon: 'DollarOutlined',
    color: '#f5222d'
  },
  profit: {
    key: 'profit',
    label: '利润分析',
    description: '成本、售价、利润等财务指标',
    order: 6,
    collapsible: true,
    defaultExpanded: true,
    icon: 'TrophyOutlined',
    color: '#fa8c16'
  },
  metadata: {
    key: 'metadata',
    label: '元数据',
    description: '创建时间、更新时间等系统信息',
    order: 7,
    collapsible: true,
    defaultExpanded: false,
    icon: 'ClockCircleOutlined',
    color: '#8c8c8c'
  }
};

// 工厂选项
export const FACTORY_OPTIONS: SelectOption[] = [
  { label: '太元', value: '太元', color: '#1890ff' },
  { label: '调理一厂', value: '调理一厂', color: '#52c41a' },
  { label: '调理二厂', value: '调理二厂', color: '#faad14' }
];

// 成本类型选项
export const COST_TYPE_OPTIONS: SelectOption[] = [
  { label: '内销', value: '内销', color: '#52c41a' },
  { label: '出口', value: '出口', color: '#1890ff' }
];

// 字段映射配置
export const FIELD_MAPPING: Record<string, FieldConfig> = {
  // ID字段
  id: {
    key: 'id',
    label: 'ID',
    type: 'text',
    group: 'metadata',
    sortable: true,
    filterable: false,
    searchable: false,
    width: 80,
    description: '记录唯一标识',
    helpText: '数据记录的唯一标识符'
  },












  // 基础信息组 (4个字段) - 驼峰命名法版本
  factoryName: {
    key: 'factoryName',
    label: '工厂名称',
    type: 'select',
    group: 'basic',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 120,
    required: true,
    options: FACTORY_OPTIONS,
    description: '生产工厂名称',
    helpText: '选择产品生产的工厂'
  },
  month: {
    key: 'month',
    label: '月份',
    type: 'date',
    group: 'basic',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 100,
    required: true,
    format: 'YYYY.MM',
    description: '数据统计月份',
    helpText: '格式：YYYY.MM，如2024.01'
  },
  costType: {
    key: 'costType',
    label: '成本类型',
    type: 'select',
    group: 'basic',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 100,
    required: true,
    options: COST_TYPE_OPTIONS,
    description: '产品销售类型',
    helpText: '内销或出口产品'
  },
  sourceTable: {
    key: 'sourceTable',
    label: '数据来源',
    type: 'text',
    group: 'basic',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 120,
    description: '原始数据表名',
    helpText: '用于追踪数据来源'
  },

  // 产品信息组 (4个字段)
  productCode: {
    key: 'productCode',
    label: '产品代码',
    type: 'text',
    group: 'product',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 120,
    description: '产品编码或存货编码',
    helpText: '产品的唯一标识代码'
  },
  productName: {
    key: 'productName',
    label: '产品名称',
    type: 'text',
    group: 'product',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 150,
    description: '产品品名',
    helpText: '产品的具体名称'
  },
  rawMaterialName: {
    key: 'rawMaterialName',
    label: '原料名称',
    type: 'text',
    group: 'product',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 120,
    description: '主要原料名称',
    helpText: '生产该产品的主要原料'
  },
  rawMaterialCode: {
    key: 'rawMaterialCode',
    label: '原料代码',
    type: 'text',
    group: 'product',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 120,
    description: '原料编码',
    helpText: '原料的唯一标识代码'
  },
  rawMaterialSpec: {
    key: 'rawMaterialSpec',
    label: '原料规格',
    type: 'text',
    group: 'product',
    sortable: true,
    filterable: true,
    searchable: true,
    width: 120,
    description: '原料规格说明',
    helpText: '原料的具体规格要求'
  },

  // 数量信息组 (7个字段)
  rawMaterialQuantity: {
    key: 'rawMaterialQuantity',
    label: '原料用量',
    type: 'number',
    group: 'quantity',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 110,
    format: 'number',
    unit: 'kg',
    precision: 0,
    description: '原料使用数量',
    helpText: '生产中实际使用的原料数量'
  },
  defectQuantity: {
    key: 'defectQuantity',
    label: '次品数量',
    type: 'number',
    group: 'quantity',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 110,
    format: 'number',
    unit: 'kg',
    precision: 0,
    description: '次品重量',
    helpText: '生产过程中产生的次品数量'
  },
  preInspectionRaw: {
    key: 'preInspectionRaw',
    label: '检前原料',
    type: 'number',
    group: 'quantity',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 110,
    format: 'number',
    unit: 'kg',
    precision: 0,
    description: '检验前原料数量',
    helpText: '原料检验前的重量'
  },
  postInspectionRaw: {
    key: 'postInspectionRaw',
    label: '检后原料',
    type: 'number',
    group: 'quantity',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 110,
    format: 'number',
    unit: 'kg',
    precision: 0,
    description: '检验后原料数量',
    helpText: '原料检验后的重量'
  },
  lossQuantity: {
    key: 'lossQuantity',
    label: '亏耗数量',
    type: 'number',
    group: 'quantity',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 110,
    format: 'number',
    unit: 'kg',
    precision: 0,
    description: '亏耗重量',
    helpText: '生产过程中的损耗数量'
  },
  outputQuantity: {
    key: 'outputQuantity',
    label: '产量',
    type: 'number',
    group: 'quantity',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'number',
    unit: 'kg',
    precision: 0,
    description: '总产量',
    helpText: '最终产品的总重量'
  },

  // 比率指标组 (8个字段)
  lossRate: {
    key: 'lossRate',
    label: '亏耗率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '生产亏耗比率',
    helpText: '亏耗数量占原料的百分比'
  },
  defectiveRate: {
    key: 'defectiveRate',
    label: '次品率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '次品产生比率',
    helpText: '次品数量占总产量的百分比'
  },
  yieldRate: {
    key: 'yieldRate',
    label: '出成率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '产品出成比率',
    helpText: '成品数量占原料的百分比'
  },
  standardYieldRate: {
    key: 'standardYieldRate',
    label: '标准出成率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '标准出成比率',
    helpText: '企业制定的标准出成率'
  },
  thinPasteRate: {
    key: 'thinPasteRate',
    label: '上稀浆率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '稀浆使用比率',
    helpText: '稀浆用量占总量的百分比'
  },
  thickPasteRate: {
    key: 'thickPasteRate',
    label: '上浓浆率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '浓浆使用比率',
    helpText: '浓浆用量占总量的百分比'
  },
  prePowderRate: {
    key: 'prePowderRate',
    label: '上预粉率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '预粉使用比率',
    helpText: '预粉用量占总量的百分比'
  },
  externalPowderRate: {
    key: 'externalPowderRate',
    label: '上外粉率',
    type: 'percentage',
    group: 'rates',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'percentage',
    precision: 2,
    range: [0, 100],
    description: '外粉使用比率',
    helpText: '外粉用量占总量的百分比'
  },

  // 成本明细组 (20个字段)
  rawMaterialUnitPrice: {
    key: 'rawMaterialUnitPrice',
    label: '原料单价',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 130,
    format: 'currency',
    precision: 0,
    description: '原料采购单价',
    helpText: '每公斤原料的采购价格'
  },
  threadingUnitPrice: {
    key: 'threadingUnitPrice',
    label: '穿串单价',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '穿串加工单价',
    helpText: '穿串加工的单位价格'
  },
  rawMaterialCost: {
    key: 'rawMaterialCost',
    label: '原料成本',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 140,
    format: 'currency',
    precision: 0,
    description: '原料总成本',
    helpText: '生产该产品的原料总费用'
  },
  standardLaborCost: {
    key: 'standardLaborCost',
    label: '标准人工',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '标准人工成本',
    helpText: '企业制定的标准人工费用'
  },
  laborCost: {
    key: 'laborCost',
    label: '人工成本',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '实际人工成本',
    helpText: '车间实际发生的人工费用'
  },
  manufacturingCost: {
    key: 'manufacturingCost',
    label: '制造费用',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '制造费用',
    helpText: '生产过程中的制造费用'
  },
  utilityCost: {
    key: 'utilityCost',
    label: '公用事业费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '公用事业费用',
    helpText: '水电气等公用事业费用'
  },
  waterCost: {
    key: 'waterCost',
    label: '水费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '用水费用',
    helpText: '生产过程中的用水成本'
  },
  electricityCost: {
    key: 'electricityCost',
    label: '电费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '用电费用',
    helpText: '生产过程中的用电成本'
  },
  steamCost: {
    key: 'steamCost',
    label: '汽费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '蒸汽费用',
    helpText: '生产过程中的蒸汽成本'
  },
  gasCost: {
    key: 'gasCost',
    label: '天然气费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 110,
    format: 'currency',
    precision: 0,
    description: '天然气费用',
    helpText: '生产过程中的天然气成本'
  },
  fuelCost: {
    key: 'fuelCost',
    label: '燃料费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '燃料费用',
    helpText: '生产过程中的燃料成本'
  },
  oilCost: {
    key: 'oilCost',
    label: '油费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '油料费用',
    helpText: '生产过程中的油料成本'
  },
  oilConsumptionPerTon: {
    key: 'oilConsumptionPerTon',
    label: '吨油耗',
    type: 'number',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'number',
    unit: 'L/t',
    precision: 0,
    description: '每吨产品油耗',
    helpText: '生产每吨产品的油料消耗量'
  },
  carbonCost: {
    key: 'carbonCost',
    label: '碳费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '碳材料费用',
    helpText: '生产过程中的碳材料成本'
  },
  liquidAmmoniaCost: {
    key: 'liquidAmmoniaCost',
    label: '液氨费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '液氨费用',
    helpText: '生产过程中的液氨成本'
  },
  liquidNitrogenCost: {
    key: 'liquidNitrogenCost',
    label: '液氮费',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '液氮费用',
    helpText: '生产过程中的液氮成本'
  },
  auxiliaryMaterialCost: {
    key: 'auxiliaryMaterialCost',
    label: '辅料成本',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '辅助材料费用',
    helpText: '生产过程中的辅助材料成本'
  },
  packagingCost: {
    key: 'packagingCost',
    label: '包装成本',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '包装材料费用',
    helpText: '产品包装的材料和人工成本'
  },
  transportationCost: {
    key: 'transportationCost',
    label: '运输费用',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '运输费用',
    helpText: '产品运输相关的费用'
  },
  fixedCost: {
    key: 'fixedCost',
    label: '固定费用',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '固定费用分摊',
    helpText: '分摊到该产品的固定费用'
  },
  salesCost: {
    key: 'salesCost',
    label: '销售费用',
    type: 'currency',
    group: 'costs',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '销售相关费用',
    helpText: '销售该产品产生的费用'
  },

  // 利润分析组 (5个字段)
  unitCostExcludingTax: {
    key: 'unitCostExcludingTax',
    label: '无税吨成本',
    type: 'currency',
    group: 'profit',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 130,
    format: 'currency',
    precision: 0,
    description: '不含税的单位成本',
    helpText: '每吨产品的不含税成本'
  },
  unitCostIncludingTax: {
    key: 'unitCostIncludingTax',
    label: '含税吨成本',
    type: 'currency',
    group: 'profit',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 130,
    format: 'currency',
    precision: 0,
    description: '含税的单位成本',
    helpText: '每吨产品的含税成本'
  },
  sellingPriceExcludingTax: {
    key: 'sellingPriceExcludingTax',
    label: '无税售价',
    type: 'currency',
    group: 'profit',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '不含税销售价格',
    helpText: '产品的不含税销售价格'
  },
  incomeTax: {
    key: 'incomeTax',
    label: '所得税',
    type: 'currency',
    group: 'profit',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 100,
    format: 'currency',
    precision: 0,
    description: '所得税费用',
    helpText: '该产品应缴纳的所得税'
  },
  profitPerTon: {
    key: 'profitPerTon',
    label: '吨利润',
    type: 'currency',
    group: 'profit',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 120,
    format: 'currency',
    precision: 0,
    description: '每吨产品利润',
    helpText: '每吨产品的净利润'
  },

  // 元数据组 (2个字段)
  createdAt: {
    key: 'createdAt',
    label: '创建时间',
    type: 'datetime',
    group: 'metadata',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 150,
    format: 'datetime',
    description: '记录创建时间',
    helpText: '数据记录的创建时间'
  },
  updatedAt: {
    key: 'updatedAt',
    label: '更新时间',
    type: 'datetime',
    group: 'metadata',
    sortable: true,
    filterable: true,
    searchable: false,
    width: 150,
    format: 'datetime',
    description: '记录更新时间',
    helpText: '数据记录的最后更新时间'
  }
};

// 默认显示列配置
export const DEFAULT_VISIBLE_COLUMNS = [
  'factoryName',
  'month',
  'costType',
  'productCode',
  'productName',
  'outputQuantity',
  'rawMaterialCost',
  'laborCost',
  'unitCostExcludingTax',
  'profitPerTon'
];

// 常用筛选字段
export const COMMON_FILTER_FIELDS = [
  'factoryName',
  'month',
  'costType',
  'productName',
  'profitPerTon'
];

// 常用排序字段
export const COMMON_SORT_FIELDS = [
  'month',
  'factoryName',
  'productName',
  'outputQuantity',
  'profitPerTon',
  'unitCostExcludingTax'
];
